import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getToken } from "./server";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import CorporateApprovals from "./pages/CorporateApprovals";
import Drivers from "./pages/Drivers";
import Products from "./pages/Products";
import Orders from "./pages/Orders";
import OrderDetails from "./pages/OrderDetails";
import Notifications from "./pages/Notifications";
import SupportTickets from "./pages/SupportTickets";
import DailyReport from "./pages/DailyReport";
import MonthlyReport from "./pages/MonthlyReport";
import HomePage from "./pages/Home";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PrivateRoute({ children }) {
  return getToken() ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard"            element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/customers"            element={<PrivateRoute><Customers /></PrivateRoute>} />
        <Route path="/corporate-approvals"  element={<PrivateRoute><CorporateApprovals /></PrivateRoute>} />
        <Route path="/drivers"              element={<PrivateRoute><Drivers /></PrivateRoute>} />
        <Route path="/products"             element={<PrivateRoute><Products /></PrivateRoute>} />
        <Route path="/orders"               element={<PrivateRoute><Orders /></PrivateRoute>} />
        <Route path="/orders/:id"           element={<PrivateRoute><OrderDetails /></PrivateRoute>} />
        <Route path="/notifications"        element={<PrivateRoute><Notifications /></PrivateRoute>} />
        <Route path="/support"              element={<PrivateRoute><SupportTickets /></PrivateRoute>} />
        <Route path="/daily-report"         element={<PrivateRoute><DailyReport /></PrivateRoute>} />
        <Route path="/monthly-report"       element={<PrivateRoute><MonthlyReport /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
